<template>
  <span>
    <vue-editor @change="changeProp" v-model="field.params.html"></vue-editor>
  </span>
</template>

<script>
import { VueEditor } from "vue2-editor";
import WidgetPropMixin from "../WidgetPropMixin.js";

export default {
  name: "StatichtmlProps",
  components: { VueEditor },
  mixins: [WidgetPropMixin],
};
</script>
